<template>
  <transition
    :css="animation.css"
    :name="animation.name"
    :mode="animation.mode"
    @enter="animation.css ? null : animation.enter"
    @leave="animation.css ? null : animation.leave"
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },
};
</script>

<style lang="scss" scoped>
.c-template.c-template--cookie {
  box-sizing: border-box;
  position: fixed;
  width: 95%;
  left: 2.5%;

  @include mq($from: ipadP) {
    width: 800px;
    left: 50%;
    margin-left: -400px;
  }

  &[data-theme="default"] {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 14px;
    bottom: 0px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: calc((100vh / 18) * 0.5) calc((100vw / 32) * 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $color-white;
    color: $color-dark;
  }
}
</style>
